import {
    Component,
    ComponentFactoryResolver,
    createNgModuleRef,
    Injector,
    OnInit,
    ViewChild,
    ViewContainerRef
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'product-blueprint-modeler-dynamic-load',
    template: '<ng-container #container></ng-container>',
    standalone: false
})
export class ProductBlueprintModelerLoadDynamic implements OnInit {
    @ViewChild('container', { read: ViewContainerRef, static: true }) container: ViewContainerRef;

    constructor(
        private route: ActivatedRoute,
        private cfr: ComponentFactoryResolver,
        private injector: Injector
    ) { }

    ngOnInit(): void {
        this.loadDynamicComponent();
    }

    async loadDynamicComponent() {
        const routeSegments = this.route.snapshot.url;
        const lastSegmentIndex = routeSegments.length - 1;
        const componentName = lastSegmentIndex >= 0 ? routeSegments[lastSegmentIndex].path : 'productBlueprintModeler';

        const { ProductBlueprintModelerModule } = await import('./product-blueprint-modeler.module');
        const componentToLoad = this.getComponentToLoad(ProductBlueprintModelerModule, componentName);
        const moduleRef = createNgModuleRef(ProductBlueprintModelerModule, this.injector);
        this.container.createComponent(componentToLoad, { ngModuleRef: moduleRef });
    }

    getComponentToLoad(module: any, componentName: string): any {
        switch (componentName) {
        case 'designer':
            return module.components.designerComponent;
        default:
            return module.components.homeComponent;
        }
    }
}
